import { useEffect, useRef, useState } from "react";

// Soft cursor spotlight — only on desktop hover-capable devices. Used on hero.
export default function CursorSpot({ containerRef, size = 520 }) {
  const dotRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const canHover = window.matchMedia("(hover: hover)").matches;
    if (!canHover) return;
    const el = containerRef.current;
    if (!el) return;

    let raf, x = 0, y = 0, tx = 0, ty = 0;
    const move = (e) => {
      const r = el.getBoundingClientRect();
      tx = e.clientX - r.left;
      ty = e.clientY - r.top;
    };
    const enter = () => setVisible(true);
    const leave = () => setVisible(false);
    const loop = () => {
      x += (tx - x) * 0.12;
      y += (ty - y) * 0.12;
      if (dotRef.current) dotRef.current.style.transform = `translate3d(${x - size/2}px, ${y - size/2}px, 0)`;
      raf = requestAnimationFrame(loop);
    };
    el.addEventListener("mousemove", move);
    el.addEventListener("mouseenter", enter);
    el.addEventListener("mouseleave", leave);
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener("mousemove", move);
      el.removeEventListener("mouseenter", enter);
      el.removeEventListener("mouseleave", leave);
    };
  }, [containerRef, size]);

  return (
    <div
      ref={dotRef}
      aria-hidden="true"
      className={`pointer-events-none absolute top-0 left-0 rounded-full transition-opacity duration-500 mix-blend-plus-lighter ${visible ? "opacity-100" : "opacity-0"}`}
      style={{
        width: size,
        height: size,
        background: "radial-gradient(circle at center, rgba(255,255,255,0.35), rgba(255,255,255,0.06) 40%, transparent 65%)",
        filter: "blur(6px)",
      }}
    />
  );
}
